import { Injectable } from '@angular/core';
import { MetadataResource } from './metadata.resource';

@Injectable({
  providedIn: 'root',
})
export class EducationLevelService extends MetadataResource {
  constructor() {
    super('education-level');
  }
}
